import { values } from '@morf/proto/values/v1/values_ts_proto';
import { formatValueDateToMoment } from './formatValueDateToMoment';

export const formatValueDateToDay = (valueDate: values.v1.Date): string =>
  formatValueDateToMoment(valueDate).format('DD'); // 'DD' for 2-digit day of the month (e.g., "03")
